import {DELIVERY} from "../../../../constants";

export default {
    state: {
        step: 1,
    },

    getters: {
        currentStep(state) {
            return state.step;
        },
        isCompleteStep1(state, getters, rootState, rootGetters) {
            if (getters.isJuridicalPerson) {
                return !!rootGetters['locations/getOrderCity'] &&
                    !!getters.isCustomerFormComplete &&
                    !!getters.isRequisitesFormComplete
            }
            if (!getters.isJuridicalPerson) {
                return !!rootGetters['locations/getOrderCity'] &&
                    !!getters.isCustomerFormComplete
            }
        },
        isCompleteStep2(state, getters) {
            if(state.selectedDelivery.type === DELIVERY.COURIER)
                return !!state.selectedPayment && getters.isAddress1Complete && !!state.address2
            if(state.selectedDelivery.type === DELIVERY.POST)
                return !!state.selectedPayment && getters.isAddress1Complete
            return !!state.selectedPayment && !!state.selectedDelivery
        },
        isCompleteStep3(state, getters) {
            return getters.isRecipientFormComplete
        },
    },

    mutations: {
        incrementStep(state) {
            state.step++;
        },
        decrementStep(state) {
            state.step--;
        },
        setStep(state, newStep) {
            state.step = newStep;
        },
    }
}
